import React from "react";
//@ts-ignore
import IntlMessages from "@util/IntlMessages";
import GlobalSettings from "../GlobalSettings/GlobalSettingsModal";
import { Tabs } from "../../../BP2Components";
import TabPane from "../../../BP2Components/Tabs/TabPane";
import StripeWidgetSettings from "./StripeWidgetSettings";

const StripeWidgetSettingsModal = (props) => {
   return (
      <Tabs defaultActiveKey="1">
         <TabPane tab={<IntlMessages id="settings.globalSettings" />} key="1">
            <GlobalSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.widgetSettings" />} key="2">
            <StripeWidgetSettings {...props} />
         </TabPane>
      </Tabs>
   );
};

export default StripeWidgetSettingsModal;
